import { PROVIDER_CURRENT_VERSION as PROVIDER_CURRENT_NEWS_VERSION } from '../../components/pages/ProviderNewsPage'
import { PatientDependentFragment } from '../../constants/types'
import {
  getFontSize,
  getIsHighContrast,
  getProviderNewsVersion,
  setFontSize,
  setIsHighContrast,
  setProviderNewsVersion,
} from '../../lib/storage'
import { resolvers as baseResolvers } from './schema'
// @ts-ignore
import { apolloMutationCount } from './schema' // eslint-disable-line
import CURRENT_DEPENDENT_QUERY from './CurrentDependentQuery.gql'
import GUI_QUERY from './GuiQuery.gql'

export interface CurrentDependentClientProps {
  __typename: string
  currentDependent: PatientDependentFragment | null
}

export const currentDependentDefaultProps: CurrentDependentClientProps = {
  __typename: 'Dependent',
  currentDependent: null,
}

const updateCurrentDependent = (input, cache) => {
  const { currentDependent } = cache.readQuery({
    query: CURRENT_DEPENDENT_QUERY,
  })
  cache.writeQuery({
    data: {
      currentDependent: {
        __typename: currentDependentDefaultProps.__typename,
        ...currentDependent,
        ...input,
      },
    },
    query: CURRENT_DEPENDENT_QUERY,
  })
  //@ts-ignore
  apolloMutationCount++
  return null
}

export interface GuiClientProps {
  __typename: string
  fontSize: number
  hasSeenLatestProviderNews: boolean
  isEncounterPanelOpen: boolean
  isHighContrast: boolean
  isInfoPanelOpen: boolean
}

export const guiDefaultProps: GuiClientProps = {
  __typename: 'Gui',
  fontSize: getFontSize(),
  hasSeenLatestProviderNews:
    getProviderNewsVersion() === PROVIDER_CURRENT_NEWS_VERSION,
  isEncounterPanelOpen: false,
  isHighContrast: getIsHighContrast(),
  isInfoPanelOpen: false,
}

const updateGui = (input, cache) => {
  const { gui } = cache.readQuery({ query: GUI_QUERY })
  let hasSeenLatestProviderNews = gui.hasSeenLatestProviderNews
  if (input && input.hasOwnProperty('fontSize')) {
    setFontSize(input.fontSize)
  }
  if (input && input.hasOwnProperty('providerNewsVersion')) {
    hasSeenLatestProviderNews =
      Number(input.providerNewsVersion) === PROVIDER_CURRENT_NEWS_VERSION
    setProviderNewsVersion(input.providerNewsVersion)
  }
  if (input && input.hasOwnProperty('isHighContrast')) {
    setIsHighContrast(input.isHighContrast)
  }
  cache.writeQuery({
    data: {
      gui: {
        __typename: guiDefaultProps.__typename,
        ...gui,
        ...input,
        hasSeenLatestProviderNews,
      },
    },
    query: GUI_QUERY,
  })
  //@ts-ignore
  apolloMutationCount++
  return null
}

const resolvers: any = { ...baseResolvers }

resolvers.Mutation.updateCurrentDependent = (_, { input }, { cache }) =>
  updateCurrentDependent(input, cache)
resolvers.Mutation.updateGui = (_, { input }, { cache }) =>
  updateGui(input, cache)
resolvers.Query.currentDependent = () => currentDependentDefaultProps
resolvers.Query.gui = () => guiDefaultProps

export { resolvers }
